import { createReducer, on } from '@ngrx/store';
import { manualChangeOpenState, manualCloseAll, manualUpdate } from './manual_setup_actions';
import { initialManualSetupState } from './manual_setup_state';

export const manualSetupReducer = createReducer(
  initialManualSetupState,
  on(manualUpdate, (state, action) => ({...state, accordionItems: action.accordionItems})),
  on(manualChangeOpenState, (state, action) => {
    let accordionItems = state.accordionItems.map(item => {
      if (item.component === action.itemToChange.component) {
        return {...item, active: !action.itemToChange.active};
      }
      return {...item};
    });
    return {
      ...state,
      accordionItems
    };
  }),
  on(manualCloseAll, (state) => {
    return {
      ...state,
      accordionItems: state.accordionItems.map(item => {
        return {...item, active: false};
      })
    };
  }),
);
